module.exports = __webpack_public_path__ + "static/img/字体设计.2d303b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10003/字体设计.png
// module id = qYmF
// module chunks = 1